// Copyright (c) 2016 Deere & Company

import UseAmount, { getDefaultState as getUseAmountDefaultState } from './use-amount';
import t from 'tcomb';

const MeasurementReading = t.struct({
    date: t.Number,
    description: t.String,
    documentNumber: t.String,
    useAmount: UseAmount,
}, {
    name: 'MeasurementReading',
    strict: true,
});

export const getDefaultState = () => new MeasurementReading({
    date: 0,
    description: '',
    documentNumber: '',
    useAmount: getUseAmountDefaultState(),
});

export default MeasurementReading;
